import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Alert/sgds-alert";
import { register } from "../../utils/ce-registry";

register("sgds-alert", Component);

export default createComponent({
  react: React,
  tagName: "sgds-alert",
  elementClass: Component,
  events: {
    onSgdsShow: "sgds-show",
    onSgdsHide: "sgds-hide"
  }
});
